import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownEventType, Option } from 'src/app/shared/interfaces/form-fields';

@Component({
  selector: 'app-page-size',
  templateUrl: './page-size.component.html',
  styleUrls: ['./page-size.component.scss']
})
export class PageSizeComponent implements OnInit {

  @Input() pageSize: number;
  @Input() recordsTotal: number;
  @Output() pageSizeChange = new EventEmitter<number>();

  pageSizes: Option[] = [
    { label: '10 rows', value: 10 },
    { label: '25 rows', value: 25 },
    { label: '50 rows', value: 50 },
    { label: '100 rows', value: 100 }
  ];
  
  constructor() { }
  
  ngOnInit(): void {
  }
  
  onPageSizeChange(event: DropdownEventType) {
    this.pageSizeChange.emit(parseInt(event.value));
  }

}

